import { Hero } from "@/components/Hero";
import { Banner } from "@/components/Banner";
import { Skeleton } from "@/components/Skeleton";

import { QREditorSkeleton } from "./QREditorSkeleton";

import "./styles.scss";

export const QREditorSkeletonWrapper = () => {
  return (
    <Banner
      xsmall
      light
      noCenter
    >
      <div className="qr-editor-skeleton__wrapper">
        <Skeleton
          width="60%"
          height="36px"
        />
        <Skeleton
          width="40%"
          height="24px"
        />
      </div>
      <Hero>
        <div className="qr-editor-skeleton__wrapper-container">
          <QREditorSkeleton />
        </div>
      </Hero>
    </Banner>
  );
};
